enum AddressType {
    home,
    work,
    other
}

export default AddressType;